'use strict'

module.exports =
  toHash: ->
    href = window.location.href
    aOpen = "<a href='#{href}'>"
    aClose = "</a>"
    breakline = "<br>"

    error_message_header: I18n.translate 'js.modules.browse.presenters.error_message.message_header'
    error_message_content_p1: I18n.translate 'js.modules.browse.presenters.error_message.message_content_p1', { aOpen, aClose }
    error_message_content_p2: I18n.translate 'js.modules.browse.presenters.error_message.message_content_p2', { breakline }
